// Cardiac subsection form field enum
export enum CardiacFormField {
  CARDIAC_STATUS = 'medical-background/cardiac/cardiac-status',
  CARDIAC_ABNORMAL_FACTORS = 'medical-background/cardiac/cardiac-abnormal-factors',
  CARDIAC_HEART_SOUNDS = 'medical-background/cardiac/heart-sounds',
  CARDIAC_SYSTEM_SUMMARY = 'medical-background/cardiac/system-summary'
}
